import moment from 'moment';

export const UploadOrdersFileActions = {
	UPLOAD: 'UPLOAD',
	PROCESSING: 'PROCESSING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
	FILE_ERRORS: 'FILE_ERRORS',
};

export const ShippingOptions = {
	FULFILLED: 'FULFILLED',
	PENDING: 'PENDING',
	PROCESSING: 'PROCESSING',
	RETURNED: 'RETURNED',
	CANCELLED: 'CANCELLED',
	BACKORDER: 'BACKORDER',
	DENTIRAHOLD: 'DentiraHold',
};

export const NON_CANCELLABLE_STATUSES = [ShippingOptions.FULFILLED, ShippingOptions.CANCELLED, ShippingOptions.DENTIRAHOLD, ShippingOptions.RETURNED];
export const isCancellableLine = (line) => !NON_CANCELLABLE_STATUSES.includes(line.status);

export const OrderStatus = {
	ORDER_PLACED: { label: 'Order Placed', color: '#B8E8F2' },
	ACCEPTED: { label: 'Accepted', color: '#B8E8F2' },
	PENDING: { label: 'Pending', color: '#FADE8E' },
	PROCESSING: { label: 'Processing', color: '#FADE8E' },
	PARTIALLY_FULFILLED: { label: 'Partially Fulfilled', color: '#F6D69E' },
	FULFILLED: { label: 'Fulfilled', color: '#C0F4BE' },
	SHIPPED: { label: 'Shipped', color: '#C0F4BE' },
	COMPLETED: { label: 'Completed', color: '#C0F4BE' },
	CANCELLED: { label: 'Cancelled', color: '#D15A64' },
	RETURNED: { label: 'Returned', color: '#A31824' },
	BACKORDER: { label: 'Backordered', color: '#F6D69E' },
};

export const CancelReasons = ['Out of stock', 'Item discontinued', 'Customer requested', 'Pricing error', 'Duplicate order'];

export const BackorderPresets = {
	ONE_WEEK: '1_WEEK',
	TWO_WEEKS: '2_WEEKS',
	THIRTY_DAYS: '30_DAYS',
	CUSTOM: 'CUSTOM',
};

export const COMMENT_MAX_LENGTH = 500;

export const formatShipByDate = (date) => {
	if (!date)
		return '';

	const d = new Date(date);
	const day = d.getDate();
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	return `${day < 10 ? '0' + day : day} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatCancelledAt = (date) => {
	if (!date)
		return '';

	return moment(date).format('D MMM YYYY, h:mm A');
};

export const looksLikeUrl = (value) => /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value) || value.startsWith('//');
export const isAllowedTrackingUrl = (value) => /^https?:\/\//i.test(value);

export const formatEstimatedDeliveryDate = (date) => {
	if (!date)
		return '';

	const d = new Date(date);
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

export const getOrderStatusLabel = (status) => {
	if(!status){
		return OrderStatus.ORDER_PLACED.label;
	}else if (Object.keys(OrderStatus).includes(status.toUpperCase())) {
		return OrderStatus[status.toUpperCase()].label;
	}
	return status;
};

export const getOrderStatusColor = (status) => {
	if(!status){
		return OrderStatus.ORDER_PLACED.color;
	}else if (Object.keys(OrderStatus).includes(status.toUpperCase())) {
		return OrderStatus[status.toUpperCase()].color;
	}
	return '#E9F3F7';
};
